<template lang='pug'>
  v-container(fill-height)
    v-row(justify='center')
      v-col(cols='10' md='8' lg='6' xl='6')
        v-col.front-text(align='center' justify='end')
          .text-h4.blue-grey--text.text--darken-1 Request Resend
          .text-h6.blue-grey--text.text--darken-2 Request a resend by email below.
        v-col
          form#requestForm(@submit.prevent='requestResend')
            v-text-field(label='Email' prepend-icon='email' v-model='email' type='email' required)
            v-row(justify='end')
              v-btn.flush-right(color='primary' :disabled='disableButton' type='submit') Request Resend
</template>

<script>
import _ from 'lodash';
import External from '../api/external';
import Notifications from '../services/notification.service';

export default {
  name: 'Resend',
  methods: {
    async requestResend() {
      try {
        await External.resend(this.email);
        Notifications.alert('Resend sent successfully');
      } catch (e) {
        this.error(e);
      }
    },
    error(err) {
      if (_.get(err, 'response.status') === 404) {
        return Notifications.alert(`No user found with email: ${this.email}`);
      }
      console.error('An exception occurred:');
      console.error(err.response);
      return err;
    }
  },
  data() {
    return {
      email: null,
      disableButton: false
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .front-text {
    margin-bottom: 4em;
  }

  #front-links a {
    color: #546E7A;
  }

  #front-links a:link {
    text-decoration: none;
  }

  #front-links a:visited {
    text-decoration: none;
  }

  #front-links a:hover {
    color: #546E7A;
    text-decoration: underline;
  }

  #front-links a:active {
    color: #546E7A;
    text-decoration: underline;
  }
</style>
